<template>
	<div class="message-tip">
		<Message myWidth="369px" myHeight="470px">
			<template v-slot:content>
				<div class="mode-wrap">
					<div
						class="close-btn"
						@click="showOrHideRulesTipClick()"
					></div>
					<div class="title">模式设置</div>
					<div class="title2">设置积分模式：</div>
					<div class="mode-btns-wrap">
						<div
							class="mode-btn-wrap mode-btn-wrap1"
							:class="{ 'mode-btn-wrap1-active': modeFlag == 1 }"
							@click="modeClick('1')"
						>
							<div class="saved-mode-text" v-if="savedMode == 1">
								当前
							</div>
							<div class="mode-bg"></div>
							<div class="mode-btn">收益模式</div>
						</div>
						<div
							class="mode-btn-wrap mode-btn-wrap2"
							:class="{ 'mode-btn-wrap2-active': modeFlag == 2 }"
							@click="modeClick('2')"
						>
							<div class="saved-mode-text" v-if="savedMode == 2">
								当前
							</div>
							<div class="mode-bg"></div>
							<div class="mode-btn">标准模式</div>
						</div>
						<div
							class="mode-btn-wrap mode-btn-wrap3"
							:class="{
								'mode-btn-wrap3-active': modeFlag == 3,
								'saved-mode-class': savedMode == 3,
							}"
							@click="modeClick('3')"
						>
							<div class="saved-mode-text" v-if="savedMode == 3">
								当前
							</div>
							<div class="mode-bg"></div>
							<div class="mode-btn">望远镜模式</div>
						</div>
					</div>
					<div v-show="modeFlag == 1" class="mode-text-wrap">
						<div class="text1">收益模式</div>
						<div class="text2 extra">
							将缓存加入小宝驿站，赚取更多积分
						</div>
						<div class="text2">
							为小宝望远镜及本机所在局域网提供加速服务
						</div>
						<div class="tip">* 切换模式将在24小时后生效</div>
					</div>
					<div v-show="modeFlag == 2" class="mode-text-wrap">
						<div class="text1">标准模式</div>
						<div class="text2 extra">
							将少量缓存加入小宝驿站，赚取少量积分
						</div>
						<div class="text2">
							为小宝望远镜及本机所在局域网提供加速服务
						</div>
						<div class="tip">* 切换模式将在24小时后生效</div>
					</div>
					<div v-show="modeFlag == 3" class="mode-text-wrap">
						<div class="text1">望远镜模式</div>
						<div class="text2 extra">
							此模式仅提供加速服务，无法产生积分收益
						</div>
						<div class="text2">
							为小宝望远镜及本机所在局域网提供加速服务
						</div>
						<div class="tip">
							* 切换至望远镜模式后，当日无积分奖励
						</div>
					</div>
					<div class="save-btn" @click="saveClick()">保存</div>
				</div>
			</template>
		</Message>
	</div>
</template>

<script>
import Message from "./Message.vue";

export default {
	components: {
		Message,
	},
	props: {
		diskcache: Number,
		uploadspeed: Number,
		switching: Number,
	},
	data: function () {
		return {
			modeFlag: 1, //1收益模式 2标准模式 3望远镜模式
			savedMode: 1,
		};
	},
	methods: {
		saveClick: function () {
			let _that = this;
			_that.$emit("modeSaveClick", _that.modeFlag);
			_that.$emit("showOrHideModeTipClick", "hide");
		},
		modeClick: function (flag) {
			let _that = this;
			_that.modeFlag = flag;
		},
		showOrHideRulesTipClick: function () {
			//通知父组件
			let _that = this;
			_that.$emit("showOrHideModeTipClick", "hide");
		},
	},
	mounted() {
		let _that = this;
		if (_that.switching == 1) {
			//望远镜模式=关闭加速=1
			_that.savedMode = 3;
			_that.modeFlag = 3;
		} else {
			if (_that.uploadspeed == 100) {
				_that.savedMode = 1;
				_that.modeFlag = 1;
			} else {
				_that.savedMode = 2;
				_that.modeFlag = 2;
			}
		}
	},
};
</script>

<style scoped lang="less">
.message-tip {
	.mixinBg {
		background-position: center;
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.mode-wrap {
		position: relative;
		padding-top: 14px;
		box-sizing: border-box;
		height: 100%;
		.close-btn {
			background-image: url(../assets/mall/exchange_alert_close.png);
			background-size: 100% 100%;
			width: 15px;
			height: 15px;
			position: absolute;
			right: 15px;
			top: 15px;
			cursor: pointer;
		}
		.close-btn:hover {
			opacity: 0.8;
		}
		.title {
			text-align: center;
			font-size: 17px;
			color: #1a1a1a;
			font-weight: 700;
		}
		.title2 {
			margin-top: 30px;
			margin-left: 36px;
			font-size: 14px;
			color: #1a1a1a;
			font-weight: 700;
		}
		.mode-btns-wrap {
			padding-left: 34px;
			margin-top: 20px;
			margin-bottom: 21px;
			font-size: 14px;
			color: #666666;

			.mode-btn-wrap {
				position: relative;
				display: inline-block;
				padding-top: 1px;
				width: 94px;
				height: 97px;
				border-radius: 3px;
				background-color: #efefef;
				text-align: center;
				border: 1px solid #e0e0e0;
				box-sizing: border-box;
				vertical-align: top;
				overflow: hidden;

				.saved-mode-text {
					position: absolute;
					top: 3px;
					left: 3px;
					padding-left: 5px;
					padding-right: 5px;
					height: 17px;
					box-sizing: border-box;
					line-height: 17px;
					color: #244ea7;
					background-color: #e3e7ee;
					font-size: 12px;
				}

				.mode-bg {
					margin: 0 auto;
					margin-top: 22px;
					margin-bottom: 5px;
					width: 31px;
					height: 31px;
					.mixinBg();
					box-sizing: border-box;
				}
			}

			.mode-btn-wrap1 {
				.mode-bg {
					background-image: url("../assets/speedShare/sy1.svg");
				}
			}
			.mode-btn-wrap2 {
				margin-left: 10px;
				margin-right: 10px;

				.mode-bg {
					background-image: url("../assets/speedShare/bz1.svg");
				}
			}
			.mode-btn-wrap3 {
				.mode-bg {
					background-image: url("../assets/speedShare/wyj.svg");
				}
			}
			.mode-btn-wrap1-active {
				background-color: #dbe5fb;
				border: 1px solid #2460e0;
				color: #1f5de3;
				box-shadow: 0 0 20px 1px rgba(98, 121, 170, 0.2);

				.saved-mode-text {
					background-color: #fafafa;
					color: #2460e0;
				}
				.mode-bg {
					background-image: url("../assets/speedShare/sy.svg");
				}
			}
			.mode-btn-wrap1-active::after,
			.mode-btn-wrap2-active::after,
			.mode-btn-wrap3-active::after {
				content: "";
				width: 25px;
				height: 25px;
				background-image: url("../assets/speedShare/checked.svg");
				.mixinBg();
				position: absolute;
				bottom: 0;
				right: 0;
			}
			.mode-btn-wrap2-active {
				background-color: #dbe5fb;
				border: 1px solid #2460e0;
				color: #1f5de3;
				box-shadow: 0 0 20px 1px rgba(98, 121, 170, 0.2);

				.saved-mode-text {
					background-color: #fafafa;
					color: #2460e0;
				}

				.mode-bg {
					background-image: url("../assets/speedShare/bz.svg");
				}
			}
			.mode-btn-wrap3-active {
				background-color: #dbe5fb;
				border: 1px solid #2460e0;
				color: #1f5de3;
				box-shadow: 0 0 20px 1px rgba(98, 121, 170, 0.2);

				.saved-mode-text {
					background-color: #fafafa;
					color: #2460e0;
				}
				.mode-bg {
					background-image: url("../assets/speedShare/wyj1.svg");
				}
			}
		}

		.mode-text-wrap {
			position: relative;
			margin: 0 auto;
			padding-top: 14px;
			padding-left: 17px;
			padding-right: 17px;
			width: 300px;
			height: 130px;
			background-color: #f2f5fd;
			border-radius: 3px;
			font-size: 12px;
			color: #999999;
			box-sizing: border-box;

			.text1 {
				text-align: center;
				font-size: 14px;
				color: #666666;
				font-weight: 700;
			}
			.text2 {
				margin-top: 7px;
				padding-left: 12px;
				background-position: left center;
				background-size: 5px 5px;
				background-repeat: no-repeat;
				background-image: url("../assets/speedShare/checked2.svg");
			}
			.extra {
				margin-top: 14px;
			}
			.tip {
				position: absolute;
				bottom: -26px;
				left: 0;
				font-size: 12px;
				color: #e23e20;
			}
		}
		.save-btn {
			position: absolute;
			bottom: 18px;
			left: 50%;
			transform: translate(-50%, 0);
			width: 112px;
			height: 36px;
			line-height: 36px;
			color: #ffffff;
			background-color: #1f5de3;
			font-size: 14px;
			border-radius: 58px;
			text-align: center;
			font-weight: 700;
			cursor: pointer;
			box-shadow: 0 0 5px 1px rgba(155, 161, 173, 0.16);
		}
	}
}
</style>
